import Immutable from "immutable";

import createStore from "./createStore";

export const reducer = createStore({
    SET_NOTIFICATION: (state, action) => {
        const { icon, ...options } = action.notification;

        // icon needs to be set separately to avoid being converted by fromJS
        const immutableOptions = icon
            ? Immutable.fromJS(options).set("icon", icon)
            : Immutable.fromJS(options);
        return state.set(action.notificationType, immutableOptions);
    },

    OPEN_NOTIFICATION: (state, action) =>
        state.setIn([action.notificationType, "open"], "open"),

    HIDE_NOTIFICATION: (state, action) =>
        state.deleteIn([action.notificationType, "open"]),

    REMOVE_NOTIFICATION: (state, action) =>
        state.delete(action.notificationType),
});
